module.exports = __webpack_public_path__ + "img/redpagos.2e8e0fe8.png";